import React, { useState } from 'react';
import { FeatureTag } from '../ui/feature-tag';
import FeatureTagDetailModal from '../FeatureTags/FeatureTagDetailModal';
import './ClickableFeatureTag.css';

/**
 * A reusable clickable FeatureTag component that opens FeatureTagDetailModal on click
 * @param {Object} featureTag - The feature tag object (can be from task.feature_tag or full feature tag)
 * @param {Array} allFeatureTags - Array of all feature tags to find the full feature tag data
 * @param {Array} allTasks - Array of all tasks to filter tasks for the modal
 * @param {string} name - Optional custom name to display (overrides featureTag.name)
 * @param {string} color - Optional custom color (overrides featureTag.color)
 * @param {string} size - Size prop for FeatureTag component
 * @param {Object} ...props - Other props to pass to the wrapper div
 */
const ClickableFeatureTag = ({ 
    featureTag, 
    allFeatureTags = [], 
    allTasks = [],
    name,
    color,
    size = 'small',
    ...props 
}) => {
    const [selectedFeatureTag, setSelectedFeatureTag] = useState(null);
    const [isFeatureTagModalOpen, setIsFeatureTagModalOpen] = useState(false);

    if (!featureTag) {
        return null;
    }

    // Find the full feature tag data if available
    const fullFeatureTag = allFeatureTags.find(ft => ft.id === featureTag.id) || featureTag;
    
    // Filter tasks for this feature tag
    const featureTasks = allTasks.filter(task => task.feature_tag?.id === featureTag.id);

    const handleClick = (e) => {
        e.stopPropagation();
        setSelectedFeatureTag(fullFeatureTag);
        setIsFeatureTagModalOpen(true);
    };

    const handleClose = () => {
        setIsFeatureTagModalOpen(false);
        setSelectedFeatureTag(null);
    };

    return (
        <>
            <div
                className="clickable-feature-tag"
                onClick={handleClick}
                style={{ cursor: 'pointer' }}
                title="Click to view feature details"
                {...props}
            >
                <FeatureTag
                    name={name || featureTag.name}
                    color={color || featureTag.color || '#6366f1'}
                    size={size}
                />
            </div>

            {selectedFeatureTag && (
                <FeatureTagDetailModal
                    tag={selectedFeatureTag}
                    isOpen={isFeatureTagModalOpen}
                    onClose={handleClose}
                    tasks={featureTasks}
                    users={[]}
                />
            )}
        </>
    );
};

export default ClickableFeatureTag;

